import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import Builder from './Builder';
import BuilderRide from './BuilderRide';

import { getIsLoggedIn } from '../../redux/selectors';

function WithRide(props) {
    const location = useLocation();
    const isLoggedIn = useSelector(getIsLoggedIn);

    const urlParams = new URLSearchParams(location.search);
    const legacySiteId = urlParams.get('site');

    if (legacySiteId) {
        return <Redirect to={`/builder/site/${legacySiteId}`} />;
    }

    const steps = [
        {
            isFixed: true,
            target: '._jr-global-styles',
            content: (
                <div>
                    Available options in Global Styles:
                    <ul>
                        <li>Add/Update Heading & Body Typography</li>
                        <li>Body Background Color</li>
                        <li>Globally Saved Colors</li>
                    </ul>
                </div>
            ),
        },
        {
            target: '._jr-page-settings',
            content: (
                <div>
                    Available options in Page Settings:
                    <ul>
                        <li>Analytics</li>
                        <li>Page Title & Description</li>
                        <li>SEO Meta Settings</li>
                        <li>Favicon</li>
                    </ul>
                </div>
            ),
        },
    ];

    if (isLoggedIn) {
        steps.push(
            {
                target: '._jr-save-site',
                content:
                    'Save the page as draft. Changes will be saved automatically in 10 seconds',
            },
            {
                target: '._jr-publish-site',
                content: 'Publish site',
            }
        );
    }
    return (
        <BuilderRide steps={steps} jrName="jr-builder-initial">
            <Builder {...props} />
        </BuilderRide>
    );
}

export default WithRide;
